/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Why_Listening_Advantage_SectionsInputs */

const en_why_listening_advantage_sections = /** @type {(inputs: Why_Listening_Advantage_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every section, one tap away`)
};

const es_why_listening_advantage_sections = /** @type {(inputs: Why_Listening_Advantage_SectionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cada sección, a un toque`)
};

/**
* | output |
* | --- |
* | "Every section, one tap away" |
*
* @param {Why_Listening_Advantage_SectionsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const why_listening_advantage_sections = /** @type {((inputs?: Why_Listening_Advantage_SectionsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Why_Listening_Advantage_SectionsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_why_listening_advantage_sections(inputs)
	return en_why_listening_advantage_sections(inputs)
});